<template>
  <div class="page-not-found-wrapper">
    <div class="text-oops">Oops!</div>
    <b class="text-not-found">404 - PAGE NOT FOUND</b>
    <span class="text-description">
      The page you are looking for might have been removed had its name changed or is temporarily unavailable
    </span>
    <Button type="primary" @click="handleBackHomePage">GO TO HOMEPAGE</Button>
  </div>
</template>
<script>
import { Button } from "@/components";
export default {
  name: "PageNotFound",
  components: {
    Button,
  },
  methods: {
    handleBackHomePage() {
      this.$router.push({ name: "Timesheets" });
    },
  },
};
</script>

<style lang="scss" scoped>
.page-not-found-wrapper {
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  .text-oops {
    background-image: url("../../assets/images/star_background.jpg");
    background-repeat: repeat;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    font-size: 200px;
    font-weight: 700;
  }
  .text-not-found {
    font-size: 30px;
    color: #000;
  }

  .text-description {
    color: #000;
    padding: 20px 0;
  }
}
</style>
